module.exports = __webpack_public_path__ + "img/banner-peace-justice-and-strong-instituitions.303f4548.png";